{
  "063d16427da8d88a": "Facility User",
  "09fd2948a8dffd21": "Workplace",
  "0b9e49cf035bd75b": "Interviews",
  "12bd656f89dac984": "From: {{phone}}",
  "1449d5fb47172cac": "Copy email",
  "18c938b5aab50b5e": "Select a conversation to view messages",
  "198070bbff07ba8e": "Search by phone, name, or workplace...",
  "1e380e06fb20ef9f": "No facility users found",
  "203a908d5a59c019": "Receive message mock",
  "25b345c161d37ee1": "Failed to send message. Please try again.",
  "27c2ccd962c2b8dc": "Unknown error",
  "286a3af7348e8312": "Sending...",
  "347130fa83e4cbe9": "Past interviews",
  "41a39ca90a9915d7": "Failed to send mock SMS: {{message}}",
  "41a634bed37381ba": "View Profile",
  "47d2a515ef2f05b8": "Loading...",
  "50b5ff647ec2fb07": "Mock inbound SMS reply",
  "53b41938bd3d3231": "Search for a facility user by name, phone, or workplace",
  "604bf413faba50fa": "Mock SMS sent - check #knock-sms-replies-dev",
  "7136799df2d343e1": "Message body",
  "7d9eb7acb13e2462": "Close",
  "7e8cd2056da73a7f": "Title",
  "7f1a9822a78ca8f0": "Applied for {{role}}",
  "8751245b0ffb8022": "View worker",
  "8cb80a46a50f59e4": "No more messages",
  "8d849d37ac0b8b55": "Workplace User",
  "8f8c8c8142bc3bce": "Copy workplace ID",
  "92907d8c70891118": "Failed to load profile",
  "93a26b1eaff99b3a": "Send message",
  "942087cc2d41e013": "Retry",
  "969ccbd3cf6300ec": "Email",
  "ac8991ef01019cf5": "Load more",
  "ae55fc046c4cf3ae": "Failed to load conversations",
  "c21e016f5b62c9fb": "No messages yet. Send the first message below.",
  "c455e88bc6a74f2f": "Copy worker ID",
  "c7677b97318f448a": "SMS Portal",
  "ca70b50942518156": "Ops",
  "dcd1d5223f73b3a9": "Name",
  "e7887dce6f9ebb97": "View interview",
  "e9bddf7360b6dc62": "Type your message...",
  "eeaaa7b4d5d7f090": "Failed to load messages",
  "f0743d83f900e797": "Triggers the SMS-reply Slack threading flow exactly as a real inbound SMS would. Posts to #knock-sms-replies-dev. Multiple sends thread together within the LD-controlled window.",
  "f17671d83db0da48": "Load older messages",
  "f4486f0e1296fbd9": "Upcoming interviews",
  "f6f4688ff23d50c6": "Send"
}
